module.exports = __webpack_public_path__ + "img/right_img1.73ff1e22.png";